export const downloadFile = (content, fileName, mimeType) => {
  const a = document.createElement('a');
  mimeType = mimeType || 'application/octet-stream';

  if (navigator.msSaveBlob) {
    // IE10
    return navigator.msSaveBlob(new Blob([content], {type: mimeType}), fileName);
  } else if ('download' in a) {
    //html5 A[download]
    a.href = `data:${mimeType},${encodeURIComponent(content)}`;
    a.setAttribute('download', fileName);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    return true;
  }

  return false;
};

export const downloadBlob = (blob, fileName) => {
  const a = document.createElement('a');

  if (navigator && navigator.msSaveBlob) {
    // IE11
    return navigator.msSaveBlob(blob, fileName);
  } else if ('download' in a) {
    //html5 A[download]
    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.setAttribute('download', fileName);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
    return true;
  }

  return false;
};
